export default {

    siteName: "Albeshary",

}